// Tamil translations — member portal
export const portalTa = {
  header: {
    churchName: 'பாத்திமா அன்னை தேவாலயம்',
    openMenu: 'மெனு திறக்கவும்',
    accountMenu: 'கணக்கு மெனு',
    signOut: 'வெளியேறவும்',
  },
  nav: {
    overview: 'கண்ணோட்டம்',
    dashboard: 'டாஷ்போர்டு',
    analytics: 'பகுப்பாய்வு',
    zoneMap: 'மண்டல வரைபடம்',
    anbiyam: 'அன்பியம்',
    families: 'குடும்பங்கள்',
    subscriptions: 'சந்தாக்கள்',
    bulkExport: 'மொத்த ஏற்றுமதி',
    collectionReview: 'சேகரிப்பு பட்டியல் ஸ்கேன்கள்',
    cemetery: 'மயானம்',
    parish: 'திருச்சபை',
    nonParish: 'திருச்சபை அல்லாத',
    certificates: 'சான்றிதழ்கள்',
    userMgmt: 'பயனர் நிர்வாகம்',
    users: 'பயனர்கள்',
    activityLog: 'செயல்பாடு பதிவு',
  },
  login: {
    churchName: 'பாத்திமா அன்னை தேவாலயம்',
    location: 'தம்பரம், சென்னை',
    username: 'பயனர்பெயர்',
    password: 'கடவுச்சொல்',
    signIn: '✝  உள்நுழைக',
    signingIn: 'உள்நுழைகிறோம்…',
    credentials: 'ஒதுக்கப்பட்ட தேவாலய நற்சான்றுகளைப் பயன்படுத்துங்கள்',
    copyright: '© பாத்திமா தேவாலயம், தம்பரம்',
    errorRequired: 'பயனர்பெயர் மற்றும் கடவுச்சொல் தேவை.',
    errorInvalid: 'தவறான பயனர்பெயர் அல்லது கடவுச்சொல். மீண்டும் முயற்சிக்கவும்.',
  },
} as const;
